/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { ReactQueryKeys } from '@/types'
import { useContext } from 'react'
import { AxiosContext } from '@/context/Axios'

export const useConnectionDecline = () => {
  const axios = useContext(AxiosContext)
  return useMutation({
    mutationKey: [ReactQueryKeys.DECLINE_CONNECTION],
    mutationFn: async (connReqID: string) => {
      const response = await axios.api.post('ajax/connections', {
        requestType: 'connReqUpdate',
        connReqID: connReqID,
        'cliqueIDs[]': '',
        connReqStatus: 2,
        format: 'json',
      })
      return response.data
    },
  })
}
